import { SERVICE_REQUEST_STATUS } from '@/entities/service-request';
import type { ServiceRequestUrlState } from '../model/types';

export const DEFAULT_URL_STATE: ServiceRequestUrlState = {
  status: SERVICE_REQUEST_STATUS.ALL,
  search: '',
  sortField: 'createdTime',
  sortDirection: 'desc'
};
